module.exports = __webpack_public_path__ + "img/office_2.c842e70a.gif";